import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchTwilioPhoneTableAndFilterSchema } from "model/TwilioPhoneModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const TwilioPhoneContext = createContext();

export const TwilioPhoneProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [twilioPhoneContextData, setTwilioPhoneContextData] = useState();

  const fetchTwilioPhoneContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:twilioPhone", () =>
        fetchTwilioPhoneTableAndFilterSchema([])
      );
      if (response?.success) {
        setTwilioPhoneContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch twilio phone metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TwilioPhoneContext.Provider
      value={{
        fetchTwilioPhoneContextData,
        twilioPhoneContextData,
        loading,
        error,
      }}
    >
      {children}
    </TwilioPhoneContext.Provider>
  );
};

export const useTwilioPhoneContext = () => useContext(TwilioPhoneContext);
